var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "evenodd",
    d: "M94.08 49.092c0-3.404-.305-6.677-.873-9.819H48v18.568h25.833c-1.113 6-4.495 11.083-9.579 14.487v12.044h15.513c9.077-8.357 14.313-20.662 14.313-35.28",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    fillRule: "evenodd",
    d: "M47.999 96c12.96 0 23.825-4.299 31.767-11.63L64.254 72.328c-4.299 2.88-9.797 4.582-16.255 4.582-12.502 0-23.084-8.444-26.858-19.79H5.104v12.437C13.003 85.243 29.235 96 48 96",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    fillRule: "evenodd",
    d: "M21.142 57.12A28.9 28.9 0 0 1 19.636 48c0-3.164.546-6.24 1.506-9.12V26.442H5.105A48 48 0 0 0 0 47.999a48 48 0 0 0 5.105 21.557z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    fillRule: "evenodd",
    d: "M47.999 19.09c7.047 0 13.375 2.423 18.35 7.18l13.766-13.768C71.803 4.756 60.937 0 48 0 29.235 0 13.003 10.756 5.104 26.444L21.141 38.88c3.774-11.346 14.356-19.79 26.858-19.79",
    clipRule: "evenodd"
  })));
};
export default SvgGoogle;